import { Component, inject, Input, OnInit } from '@angular/core';
import { Store } from '@ngxs/store';
import { ApplicationSelectors } from '@shared/store/application/application.selectors';
import { AuthSelectors } from '@shared/store/auth/auth.selectors';
import { LanguageVersion } from '@data/common/LanguageVersion';
import { ApplicationActions } from '@shared/store/application/application.actions';
import { AuthActions } from '@shared/store/auth/auth.actions';

@Component({
  selector: 'app-side-menu',
  templateUrl: './side-menu.component.html',
  styleUrls: [ './side-menu.component.scss' ],
  standalone: false
})
export class SideMenuComponent implements OnInit {
  @Input() public menuCollapse: boolean = false;

  public LanguageVersion: typeof LanguageVersion = LanguageVersion;

  private readonly store: Store = inject(Store);

  public menuItems = this.store.selectSignal(ApplicationSelectors.menuItems);

  public language = this.store.selectSignal(ApplicationSelectors.language);

  public hasUnreadedLeaveRequests = this.store.selectSignal(AuthSelectors.hasUnreadedLeaveRequests);

  public isAdmin: boolean = false;

  public isTriagist: boolean = false;

  public isSuperUser: boolean = false;

  ngOnInit(): void {
    this.isAdmin = this.store.selectSnapshot(AuthSelectors.isAdmin);
    this.isTriagist = this.store.selectSnapshot(AuthSelectors.isTriagist);
    this.isSuperUser = this.store.selectSnapshot(AuthSelectors.isSuperUser);
  }

  public changeLanguage(language: string): void {
    this.store.dispatch(new ApplicationActions.ChangeLanguage(language as LanguageVersion));
  }

  public logOut(): void {
    this.store.dispatch(new AuthActions.Logout());
  }
}
